// MemberCollect 組件類型
export const MEMBER_COLLECT_TYPE = {
  INPUT: 'input',
  SELECT: 'select'
} as const

// MemberCollect 錯誤訊息
export const MEMBER_COLLECT_ERRORS = {
  INVALID_EMAIL: '請輸入正確的 Email',
  MEMBER_REQUIRED: '請至少選擇一位成員'
} as const

export type MemberCollectType = (typeof MEMBER_COLLECT_TYPE)[keyof typeof MEMBER_COLLECT_TYPE]
